import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./services/font/index";
import "./plugins/index";

//Directives
import Vidle from "v-idle";
import DOMPurify from "dompurify";

//Quill Styles
import "quill-better-table/dist/quill-better-table.css";
import "quill/dist/quill.core.css";

Vue.config.productionTip = false;

store.dispatch("initData").then(() => {
  Vue.use(Vidle);
  DOMPurify.addHook("afterSanitizeAttributes", function (node) {
    if ("target" in node) {
      node.setAttribute("target", "_blank");
      node.setAttribute("rel", "noopener");
    }
  });
  Vue.directive("sane-html", (el, binding) => {
    el.innerHTML = DOMPurify.sanitize(binding.value);
  });

  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount("#app");
});
